import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import SupportForm from './components/SupportForm';
import SuccessMessage from './components/SuccessMessage';
import './styles/global.css';

const App: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleFormSubmit = () => {
    setIsSubmitted(true);
  };

  return (
    <div className="app">
      <Header />
      
      <main className="main-content">
        {isSubmitted ? (
          <SuccessMessage />
        ) : (
          <SupportForm onSubmitSuccess={handleFormSubmit} />
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default App;
